import type {
  PromotedProductRuleAmount,
  PromotedProductRuleAmountFragment,
  PromotedProductRulePercentage,
  PromotedProductRulePercentageFragment,
} from '@shared/shop-api/product/attributes/types'

export const isPromotedProductRuleAmount = (
  rule: unknown
): rule is PromotedProductRuleAmount => {
  const isObject = typeof rule === 'object' && rule !== null
  const hasAttributes = isObject && 'amount' in rule && 'currencyCode' in rule
  const hasAttributesOfType =
    hasAttributes &&
    typeof rule.amount === 'number' &&
    typeof rule.currencyCode === 'string'
  const hasValues =
    hasAttributesOfType && rule.amount !== '' && rule.currencyCode !== ''

  return hasValues
}

export const isPromotedProductRulePercentage = (
  rule: unknown
): rule is PromotedProductRulePercentage => {
  const isObject = typeof rule === 'object' && rule !== null
  const hasAttributes = isObject && 'percentage' in rule
  const hasAttributesOfType =
    hasAttributes && typeof rule.percentage === 'number'

  return hasAttributesOfType
}

export const isPromotedProductRuleAmountFragment = (
  rule: unknown
): rule is PromotedProductRuleAmountFragment => {
  const isObject = typeof rule === 'object' && rule !== null
  const hasAttributes = isObject && 'amount' in rule && 'currencyCode' in rule
  const hasAttributesOfType =
    hasAttributes &&
    typeof rule.amount === 'string' &&
    typeof rule.currencyCode === 'string'
  const hasValues =
    hasAttributesOfType && rule.amount !== '' && rule.currencyCode !== ''

  return hasValues
}

export const isPromotedProductRulePercentageFragment = (
  rule: unknown
): rule is PromotedProductRulePercentageFragment => {
  const isObject = typeof rule === 'object' && rule !== null
  const hasAttributes = isObject && 'percentage' in rule
  const hasAttributesOfType =
    hasAttributes && typeof rule.percentage === 'string'
  const hasValues = hasAttributesOfType && rule.percentage !== ''

  return hasValues
}
